import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const NxaFAQBusinessPhone = () => {
  const [openQuestions, setOpenQuestions] = useState({});
  const [isMobile, setIsMobile] = useState(false);

  // ✅ Corrected useEffect (moved outside the function)
  useEffect(() => {
    const checkScreenSize = () => setIsMobile(window.innerWidth <= 768);
    checkScreenSize(); // Initial check
    window.addEventListener("resize", checkScreenSize);

    return () => window.removeEventListener("resize", checkScreenSize);
  }, []);

  // ✅ Fixed toggleQuestion function
  const toggleQuestion = (index) => {
    setOpenQuestions((prevState) => ({
      ...prevState,
      [index]: !prevState[index],
    }));
  };

  return (
    <div className="pricing-sec-1 pricing-page-faq">
      <div className="container">
        <h2 className="font--31 color-293F  fw--400">NxaTel Pricing FAQs</h2>
        <div className="row">
          {/* Question 1 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">1</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(1)}
                    aria-expanded={openQuestions[1]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What's included in each NxaTel plan?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[1] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Each plan includes a local or national phone number,
                    unlimited inbound calls, call management features,
                    voicemail, and business SMS capabilities. Higher-tier plans
                    offer advanced analytics, AI-powered tools, and increased
                    user capacity.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 2 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">2</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(2)}
                    aria-expanded={openQuestions[2]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I port my existing number to NxaTel?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[2] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! We offer a free number porting service for new users,
                    ensuring a seamless transition without downtime.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 3 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">3</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(3)}
                    aria-expanded={openQuestions[3]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Do you offer a trial period?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[3] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! Our starter and scale-up plans come with a 30-day free
                    trial so you can test the platform risk-free.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          {/* Question 4 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">4</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(4)}
                    aria-expanded={openQuestions[4]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    How does the AI call transcription feature work?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[4] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Our AI automatically transcribes calls in real time,
                    provides summaries, and scores conversations to help you
                    track interactions effectively.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 5 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">5</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(5)}
                    aria-expanded={openQuestions[5]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Can I add more users to my plan later?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[5] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Absolutely! You can scale your plan as your team grows,
                    adding users and features as needed.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 6 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">6</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(6)}
                    aria-expanded={openQuestions[6]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What kind of customer support do I get?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[6] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    All plans include access to our help center and email
                    support. Phone support and priority assistance are available
                    on higher-tier plans.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* Question 7 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">7</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(7)}
                    aria-expanded={openQuestions[7]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Do you support international calling?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[7] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes, outbound international calls are supported at
                    competitive rates. Contact us for a detailed pricing
                    breakdown.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 8 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">8</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(8)}
                    aria-expanded={openQuestions[8]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    Is my data secure with NxaTel?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[8] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    Yes! We use end-to-end encryption, role-based permissions,
                    and two-factor authentication to keep your business
                    communication secure.
                  </p>
                </div>
              </div>
            </div>
          </div>
          {/* Question 9 */}
          <div className="col-md-4">
            <div className="pricing-sec-box d-flex">
              <div className=" ">
                <div className="pricing-collapse-box">
                  <div className="number-of-box">
                    <h6 className="text--orange">9</h6>
                  </div>
                  <a
                    className="font-18 fw--400 color-293F lh--28"
                    role="button"
                    onClick={() => toggleQuestion(9)}
                    aria-expanded={openQuestions[9]}
                    aria-controls="collapseExample"
                    style={{ cursor: "pointer" }}
                  >
                    What happens if I need to cancel my plan?
                  </a>
                </div>
                <div
                  className={`collapse ${openQuestions[9] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p className="font-15 color-8087 lh--24">
                    You can cancel anytime with no hidden fees. If you're on an
                    annual plan, prorated refunds may apply.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {/* NXA Policy */}
          <div className="col-md-12">
            <div className="pricing-sec-box-policy">
              <div className=" ">
                <div
                  className="pricing-collapse-box"
                  style={{
                    alignItems: "center",
                  }}
                >
                  <div
                    className={`nxa-pol ${isMobile ? "col-9" : "col-md-11"}`}
                  >
                    NxaTel's Fair Usage Policy
                  </div>
                  <div
                    className={`text-right ${isMobile ? "col-3" : "col-md-1"}`}
                  >
                    {" "}
                    <a
                      className="font-18 fw--400 color-293F lh--28 "
                      role="button"
                      onClick={() => toggleQuestion(10)}
                      aria-expanded={openQuestions[10]}
                      aria-controls="collapseExample"
                      style={{
                        cursor: "pointer",
                        display: "flex",
                      }}
                    >
                      <div className="number-of-box ">
                        <h6 className="text--orange">
                          <i className="fas fa-chevron-down"></i>
                        </h6>
                      </div>
                    </a>
                  </div>
                </div>
                <div
                  className={`collapse ${openQuestions[10] ? "show" : ""}`}
                  id="collapseExample"
                >
                  <p style={{ marginLeft: "15px" }}>
                    NxaTel Fair Usage Policy
                    <br />
                    1.Business Use Only <br />
                    NxaTel’s services are provided exclusively for business and
                    home office use. This means you may not use them for
                    personal, residential, non-business, or non-professional
                    purposes. Additionally, reselling, transferring, or charging
                    others for the use of the service is strictly prohibited
                    unless explicitly authorized in writing by NxaTel. <br />
                    2. Prohibited Activities
                    <br />
                    Customers may not engage in auto-dialing, trunking, or
                    traffic pumping. This includes: <br />
                    • Using auto-dialing or predictive dialing systems.
                    <br />
                    • Trunking or forwarding NxaTel phone lines to numbers that
                    handle multiple simultaneous calls, PBX systems, or key
                    systems.
                    <br />
                    • Traffic pumping or access stimulation through NxaTel’s
                    network. <br />
                    3. Intended Use for Small Businesses
                    <br />
                    NxaTel’s office phone system is designed for small
                    businesses. If usage patterns indicate call center-type
                    activities, such as high-volume bulk calling, NxaTel
                    reserves the right to adjust your plan or apply standard
                    rates. Accounts that do not comply with fair usage policies
                    may be moved to call center plans or canceled.
                    <br />
                    4. Network Protection Measures <br />
                    If the system detects excessive usage that may cause
                    network, API, or system failures, NxaTel may suspend calling
                    services on your account without prior notice.
                    <br />
                    5.Unlimited Calling Exemptions
                    <br />
                    • Unlimited calling does not apply to numbers listed in the
                    NxaTel Exemption List.
                    <br />
                    • Unlimited calling is not permitted for premium, mobile, or
                    toll-free numbers.
                    <br />• Unlimited calling is only applicable to domestic
                    calls within the US and Canada. International calls will be
                    charged at the rates published on NxaTel’s pricing page.{" "}
                    <br />
                    6.Call Frequency Limitations <br />
                    • Outgoing calls to the same number are limited to 10 calls
                    per hour. Exceeding this limit will result in an automatic
                    block on the number. To unblock, a request with a valid
                    reason must be submitted to NxaTel’s support team. <br />
                    • No more than 30% of total calls can be simultaneous
                    (parallel calls) within an office phone system. <br />
                    By using NxaTel’s services, you agree to comply with this
                    Fair Usage Policy. Violations may result in service
                    adjustments, plan changes, or account termination. <br />{" "}
                    Would you like me to add any specific legal disclaimers or
                    modifications based on
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* partner logo */}
        <div className="sign-up-faq-partner-logo">
          <Link to="#" className="">
            <img src="./../assets/images/Method=Visa.svg" alt="logo" />
          </Link>
          <Link to="#" className="">
            <img src="./../assets/images/Mastercard.svg" alt="logo" />
          </Link>
          <Link to="#" className="">
            <img src="./../assets/images/Method=Stripe.svg" alt="logo" />
          </Link>
          <Link to="#" className="">
            <img src="./../assets/images/Ozwo Pay 1.svg" alt="logo" />
          </Link>
          {/* <Link to="#" className="">
            <img src="./../assets/images/voucher-log.svg" alt="logo" />
          </Link> */}
          {/* <Link to="#" className="">
            <img src="./../assets/images/blue-voucher.svg" alt="logo" />
          </Link> */}
          <Link to="#" className="">
            <img src="./../assets/images/nxa-voucher.svg" alt="logo" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NxaFAQBusinessPhone;
